

































import { Vue, Component, Watch } from 'vue-property-decorator';
import VoteButton from '@/components/VoteButton.vue';
import * as config from './config';
import { detail, userHelper } from './api/index';
import FloatLikeBtn from './components/FloatLikeBtn.vue';
import Canvas from './components/Canvas.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from './store/mutation-types';

const Modules = namespace('Graduation20200605');
@Component({
  components: {
    VoteButton,
    FloatLikeBtn,
    Canvas,
  },
})
export default class Detail extends Vue {
  option = config.OPTHINES;
  detailFirstData: any = {};
  detailData: any = {};
  detailVoteData: any = {};
  show: boolean = false;
  button: boolean = true;
  type: any;
  loading = false;
  finished = false;
  page = 1;
  createtime = '';
  extendOneAll = false;
  extendTwoAll = false;
  showExtendOneBtn = true;
  showExtendTwoBtn = true;
  typeShow = true;

  @Modules.Mutation(mutationTypes.GET_POST_LIKE) getPostLike!: (
    PostLike: any,
  ) => void;
  @Modules.Mutation(mutationTypes.UPDATE_POST_LIKE) updatePostLike!: () => void;
  @Modules.State('votes') votes!: {};

  get GradeData() {
    for (const index of Object.keys(this.option.Grades)) {
      let res = '';
      if (Number(index) === this.detailData.grade - 1) {
        res = this.option.Grades[Number(index)];
        return res;
      }
    }
  }
  @Watch('$route')
  onRouteChange(newVal: any) {
    this.fetchDetail();
  }
  created() {
    this.fetchDetail();
    userHelper().then((res) => console.log('访问userHelper'));
  }
  fetchDetail() {
    detail(this.$route.query.id).then((res) => this.getDetailData(res));
  }
  getDetailData(res: any) {
    this.detailData = res.data.content;
    this.detailVoteData = res.data;
    console.log('this.detailData', this.detailData);
    this.getPostLike(this.detailData.vote_num);
    this.getDate(res.data.content.created_at, '-', ':');
    if (res.data.content.period === 4) {
      this.typeShow = false;
    }
    // 分享
    appShare({
      title: res.data.content.title,
      url: window.location.href,
      subtitle: `${this.detailData.student}/${this.detailData.school}/${this.GradeData}/${this.detailData.class}班`,
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: res.data.content.title,
      subtitle: `${this.detailData.student}/${this.detailData.school}/${this.GradeData}/${this.detailData.class}班`,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  getDate(timestamp: any, sepDate: string, sepTime: string) {
    const date = new Date();
    date.setTime(timestamp * 1000);
    const year = date
      .getFullYear()
      .toString()
      .padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date
      .getDate()
      .toString()
      .padStart(2, '0');
    const h = date
      .getHours()
      .toString()
      .padStart(2, '0');
    const min = date
      .getMinutes()
      .toString()
      .padStart(2, '0');
    const s = date
      .getSeconds()
      .toString()
      .padStart(2, '0');
    this.createtime =
      year + '-' + month + '-' + d + '  ' + h + ':' + min + ':' + s;
  }
  votSuccess(num: string) {
    this.detailData.votes_num = num;
    this.updatePostLike();
    this.button = false;
    setTimeout(() => {
      this.button = true;
    }, 1000);
  }
}
